import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, map, Observable} from "rxjs";
import {User} from "../models/user";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('current_user')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    return this.http.post<any>('/api/login_check', {username, password})
      .pipe(map(res => {
        return res;
      }));
  }

  getAuthenticatedUser(token: string) {
    return this.http.get<any>('/api/getMe', {
      headers: {'Authorization': `Bearer ${token}`}
    })
      .pipe(map(res => {
        localStorage.setItem('jwt_token', token);
        localStorage.setItem('current_user', JSON.stringify(res.data));
        this.currentUserSubject.next(res.data);
        return res;
      }));
  }

  logout() {
    localStorage.removeItem('current_user');
    localStorage.removeItem('jwt_token');
    this.currentUserSubject.next(null);
    window.location.reload();
  }

  setRequireChangePasswordFalse() {
    let user = this.currentUserValue;
    this.currentUserValue.requireChangePassword = false;
    localStorage.setItem('current_user', JSON.stringify(user));
  }
}
